import React, { FC } from 'react';
import classNames from 'classnames';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { Button, Image } from '@whitesharx/starfall-frontend-ui-kit';
import { Modal } from '../Modal';
import { imageStyles, textStyles, marginStyles } from './styles.css';
import { buttonStyles, infoContainerStyles } from '../styles.css';

type StalemateModalProps = {
  isOpen: boolean;
  onUndoStalemate(): void;
  onRequestClose(): void;
};

const StalemateModal: FC<StalemateModalProps> = ({ isOpen, onUndoStalemate, onRequestClose }) => (
  <Modal.Chess isOpen={isOpen} onRequestClose={onRequestClose} header={t('cancel-move') + '?'} maxWidth={600}>
    <Image className={imageStyles} src="assets/images/reclining-king.avif" />
    <div className={infoContainerStyles}>
      <span className={textStyles}>{t('this-is-stalemate')}</span>
      <span className={classNames(textStyles, marginStyles)}>{t('cancel-last-move?')}</span>
      <Button className={buttonStyles} onClick={onRequestClose}>
        {t('button.continue')}
      </Button>
      <Button color="secondary" className={buttonStyles} onClick={onUndoStalemate}>
        {t('cancel-move')}
      </Button>
    </div>
  </Modal.Chess>
);

export default StalemateModal;
